var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 3.34119C17.5 3.74952 16.6834 3.91536 15.8334 4.16619C14.8992 3.11202 13.5142 3.05369 12.1834 3.55202C10.8525 4.05036 9.98085 5.26869 10 6.66619V7.49952C7.29585 7.56869 4.88752 6.33702 3.33335 4.16619C3.33335 4.16619 -0.151646 10.3604 6.66669 13.3329C5.10669 14.372 3.55085 15.0729 1.66669 14.9995C4.42335 16.502 7.42752 17.0187 10.0284 16.2637C13.0117 15.397 15.4634 13.1612 16.4042 9.81202C16.6848 8.79341 16.8242 7.74107 16.8184 6.68452C16.8167 6.47702 18.0767 4.37452 18.3334 3.34036V3.34119Z",
    stroke: "url(#paint0_linear_78_87)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_87",
    x1: 0.0281101,
    y1: -3.741,
    x2: 20.0494,
    y2: -3.53751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.247a0eb0784eb42a27e1bad8895112d9.svg";
export { ForwardRef as ReactComponent };